import Vue from 'vue'
import { API_URL } from '../../api'
import AssetsFilter from '../../filters/AssetsFilter';
const state = {
    assetCreate: {
        createdAsset: null,
        creatingAsset: false,
        createAssetStatus: null
    },
    assetUpdate: {
        updatedAsset: null,
        updatingAsset: false,
        updateAssetStatus: null
    },
    assetDelete: {
        deletingAsset: false,
        deleteAssetStatus: null
    },
    assetSearch: {
        assetsCount: null,
        assets: [],
        assetsPaginated: [],
        searchingAssets: false,
        searchAssetStatus: null
    },
}
const mutations = {
    ['SET_ASSET_CREATE'](state, change) {
        state.assetCreate = { ...state.assetCreate, ...change };
    },
    ['SET_ASSET_UPDATE'](state, change) {
        state.assetUpdate = { ...state.assetUpdate, ...change };
    },
    ['SET_ASSET_DELETE'](state, change) {
        state.assetDelete = { ...state.assetDelete, ...change };
    },
    ['SET_ASSET_SEARCH'](state, change) {
        state.assetSearch = { ...state.assetSearch, ...change };
    }
}
const actions = {
    createAsset: ({ commit }, payload) => {
        commit('SET_ASSET_CREATE', { createAssetStatus: null, createdAsset: null, creatingAsset: true })
        return Vue.http.post(API_URL + '/assets/create', payload).then(response => {
            commit('SET_ASSET_CREATE', { createAssetStatus: 'success', createdAsset: response.body.results.asset });
        }).catch(response => {
            commit('SET_ASSET_CREATE', { createAssetStatus: 'failed' });
        }).finally(() => {
            commit('SET_ASSET_CREATE', { creatingAsset: false });
        });
    },
    updateAsset: ({ commit }, payload) => {
        commit('SET_ASSET_UPDATE', { updateAssetStatus: null, updatedAsset: null, updatingAsset: true })
        return Vue.http.post(API_URL + '/assets/update/' + payload.id, payload)
            .then(response => {
                commit('SET_ASSET_UPDATE', { updateAssetStatus: 'success', updatedAsset: response.body.results.asset });
            })
            .catch(response => {
                commit('SET_ASSET_UPDATE', { updateAssetStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_ASSET_UPDATE', { updatingAsset: false });
            })
    },
    deleteAsset: ({ commit }, id) => {
        commit('SET_ASSET_DELETE', { deleteAssetStatus: null, deletedAsset: null, deletingAsset: true })
        return Vue.http.delete(API_URL + '/assets/delete/' + id).then(response => {
            commit('SET_ASSET_DELETE', { deleteAssetStatus: 'success' });
        }).catch(response => {
            commit('SET_ASSET_DELETE', { deleteAssetStatus: 'failed' });
        }).finally(() => {
            commit('SET_ASSET_DELETE', { deletingAsset: false });
        })
    },
    searchAssets: ({ commit }, payload = { filter: AssetsFilter(), resultMode: 'default' }) => {
        commit('SET_ASSET_SEARCH', { searchAssetStatus: null, searchAsset: null, searchingAssets: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/assets' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_ASSET_SEARCH', { searchAssetStatus: 'success', assetsCount: response.body.results.assets });

            } else if (payload.resultMode == 2) {
                commit('SET_ASSET_SEARCH', { searchAssetStatus: 'success', assetsPaginated: response.body.results.assets });

            } else {
                commit('SET_ASSET_SEARCH', { searchAssetStatus: 'success', assets: response.body.results.assets });
            }
        }).catch(response => {
            commit('SET_ASSET_SEARCH', { searchAssetStatus: 'failed' });
        }).finally(() => {
            commit('SET_ASSET_SEARCH', { searchingAssets: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/assetStore.js